export default __webpack_public_path__ + "static/media/left_leaf.5ec9f79d.png";